var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.options.length)?_c('div',{staticClass:"tag-filters"},_vm._l((_vm.options),function(item,ind){return _c('span',{key:item.id,staticClass:"tag-filters-item",class:{ 'selected': item.selected, 'disabled': item.disabled },on:{"click":function($event){return _vm.handleClick(ind)}}},[_vm._v(_vm._s(item.name))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }